import { render, staticRenderFns } from "./PillNav.vue?vue&type=template&id=762b5dc4&scoped=true"
import script from "./PillNav.vue?vue&type=script&lang=js"
export * from "./PillNav.vue?vue&type=script&lang=js"
import style0 from "./PillNav.vue?vue&type=style&index=0&id=762b5dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b5dc4",
  null
  
)

export default component.exports